import { render, staticRenderFns } from "./LlBoardChecklistListItem.vue?vue&type=template&id=055b6b84&scoped=true"
import script from "./LlBoardChecklistListItem.vue?vue&type=script&lang=js"
export * from "./LlBoardChecklistListItem.vue?vue&type=script&lang=js"
import style0 from "./LlBoardChecklistListItem.vue?vue&type=style&index=0&id=055b6b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055b6b84",
  null
  
)

export default component.exports